export default { sha: 'd0e653944761b51d1ae8bff8ddd3afeca527b91e', buildNumber: 'undefined' }
